import adminNav from "./adminNav";
import airportNav from "./airportNav";
import nonprofitNav from "./nonprofitNav";
import userNav from "./userNav";
import pilotNav from "./pilotNav";

export const DASHBOARD_TYPES = [
  "Admin",
  "Airport",
  "NonProfit",
  "User",
  "Pilot",
];

export const getBaseNavConfigForType = (type) => {
  const t = (type || "").toLowerCase();
  switch (t) {
    case "admin":
    case "avipair":
      return adminNav;
    case "airport":
      return airportNav;
    case "nonprofit":
      return nonprofitNav;
    case "pilot":
      return pilotNav;
    case "user":
    case "staff":
    default:
      return userNav;
  }
};

/**
 * Map token role + entityType to menu type for getBaseNavConfigForType.
 * Token drives menu; no fallback.
 */
export const getMenuTypeFromToken = (tokenRole, tokenEntityType) => {
  const entity = (tokenEntityType || "").trim();
  const role = (tokenRole || "").trim();
  if (entity === "AviPair") return "admin";
  if (entity === "Airport") return "airport";
  if (entity === "NonProfit") return "nonprofit";
  if (role === "Admin") return "admin";
  if (role === "Pilot") return "pilot";
  if (role === "Staff") return "user";
  return "user";
};
